import React from 'react';
import ReactEDSWrapper from '../../utils/react-eds-wrapper';
import { Button } from '@dsi/react-eds';
import styles from './Contribute.module.css';

const Contribute: React.FC = () => {
  const handleFeedbackClick = () => {
    console.log('Give us your Feedback clicked');
  };

  return (
    <div className={styles.contribute}>
      <div className={styles.contributeContent}>
        <h3 className={styles.contributeTitle}>Contribute to RAN LCA</h3>
        <p className={styles.contributeDescription}>
          Your opinion helps us make our software better. If you've noticed something that could be improved, have a feature 
          in mind, or just want to share your experience — we'd love to hear from you.
        </p>
        <p className={styles.contributeSubDescription}>
          Please take a moment to send us your feedback. Every suggestion is reviewed by our team and plays a key role in 
          shaping future updates.
        </p>
        <div className={styles.contributeAction}>
          <ReactEDSWrapper 
            component={Button}
            primary
            onClick={handleFeedbackClick}
          >
            Give us your Feedback
          </ReactEDSWrapper>
        </div>
      </div>
    </div>
  );
};

export default Contribute;